export default {
  'zh-CN': {
    dataDeletion: {
      title: '账号和数据删除说明',
      intro: '您可以请求删除 Fuzozo 账号、删除全部关联数据，或仅删除部分个人数据。账号注销流程设有 7 天冷静期；本页面说明提交方式、删除范围、保留原因和保留期限。',
      sections: [
        {
          title: '1. 账号注销和 7 天冷静期',
          paragraphs: ['如您希望删除账号及全部关联个人数据，可以在 Fuzozo 应用内提交账号注销申请。提交后，账号注销会进入 7 天冷静期。冷静期内，账号不会立即完成最终删除；冷静期结束且您未取消注销的，我们会删除或匿名化与该账号关联的个人数据，删除完成后账号无法恢复。'],
          steps: [
            '打开 Fuzozo 应用，并登录您要删除的账号。',
            '进入“我的”页面。',
            '滑动到页面底部并选择“删除账号”。',
            '阅读确认提示后，点击“删除”或“注销账号”提交申请。',
            '提交后进入 7 天冷静期；冷静期结束且未取消注销的，账号及关联个人数据将进入最终删除或匿名化处理。'
          ]
        },
        {
          title: '2. 删除部分数据',
          paragraphs: ['如果您只希望删除部分数据，而不是注销整个账号，可以通过邮箱提交申请。请说明您希望删除的数据类型或时间范围，例如个人资料、对话/互动记录、客服记录或其他您提供的内容。']
        },
        {
          title: '3. 提交方式',
          paragraphs: ['您可以通过应用内账号删除入口提交账号注销申请。若您无法登录账号，或需要删除部分数据，请发送邮件给我们。'],
          bullets: [
            '邮件中请提供与账号绑定的邮箱地址或其他可用于定位账号的信息。',
            '请说明您要注销账号及删除全部数据，还是仅删除部分数据。',
            '为保护账号安全，我们可能需要进行必要的身份验证后再处理请求。'
          ]
        },
        {
          title: '4. 删除范围',
          paragraphs: ['账号注销场景下，删除范围适用于 7 天冷静期结束且您未取消注销后的最终删除或匿名化处理。删除范围通常包括：'],
          bullets: [
            '账号资料和登录标识，例如账号 ID、绑定邮箱、登录授权记录。',
            '个人资料和应用内设置，例如昵称、头像、偏好设置。',
            '您在服务中生成、提交或保存的内容，例如对话、互动记录、反馈或客服沟通内容。',
            '可归属于该账号的设备信息、使用记录、错误日志和安全日志。'
          ]
        },
        {
          title: '5. 保留原因',
          paragraphs: ['以下数据可能因必要原因不会在 7 天冷静期结束后立即删除，但只会在必要范围内保存，并会在保留原因消失或保留期限届满后删除或匿名化：'],
          bullets: [
            '法律、合规、税务、会计或审计要求必须保存的记录。',
            '交易、支付、退款、发票或权益发放记录（如适用）。',
            '用于账号安全、反作弊、风控、故障排查和防止滥用的安全日志。',
            '为处理争议、投诉、客服请求或保护合法权益所必需的记录。',
            '备份系统中的数据副本。'
          ]
        },
        {
          title: '6. 保留期限',
          paragraphs: ['账号注销进入 7 天冷静期后，如您未在冷静期内取消注销，我们会在冷静期结束后删除或匿名化相关个人数据。除法律法规另有要求，或为安全、争议处理、合规审计等必要目的需要继续保留外，我们不会继续保留已注销账号的个人数据。备份系统中的数据会随备份轮换周期清除或隔离，不再用于日常业务访问。依法或出于必要目的保留的数据，将仅保存至对应目的完成或适用法律要求的期限届满。']
        }
      ],
      contactLabel: '联系邮箱：',
      contactEmail: 'support@fuzozo.net'
    }
  },
  en: {
    dataDeletion: {
      title: 'Account and Data Deletion Instructions',
      intro: 'You may request deletion of your Fuzozo account, deletion of all associated data, or deletion of selected personal data. Account deletion is subject to a 7-day cooling-off period. This page explains how to submit a request, deletion scope, retention reasons, and retention periods.',
      sections: [
        {
          title: '1. Account deletion and 7-day cooling-off period',
          paragraphs: ['If you want to delete your account and all associated personal data, you can submit an account deletion request in the Fuzozo app. After submission, account deletion enters a 7-day cooling-off period. During this period, final deletion is not completed immediately. If you do not cancel the deletion before the period ends, we will delete or anonymize personal data associated with the account. Once completed, the account cannot be restored.'],
          steps: [
            'Open the Fuzozo app and sign in to the account you want to delete.',
            'Go to the Mine page.',
            'Scroll to the bottom and select Delete Account.',
            'Read the confirmation prompt, then tap Delete or Deactivate Account to submit the request.',
            'After submission, a 7-day cooling-off period begins. If you do not cancel during this period, the account and associated personal data will enter final deletion or anonymization processing.'
          ]
        },
        {
          title: '2. Delete selected data',
          paragraphs: ['If you want to delete selected data without deleting your entire account, please submit a request by email. Include the data type or time period you want deleted, such as profile information, conversation or interaction records, customer support records, or other content you provided.']
        },
        {
          title: '3. How to submit a request',
          paragraphs: ['You can use the in-app account deletion entry to request account deletion. If you cannot access your account, or if you want to delete selected data, please email us.'],
          bullets: [
            'Include the email address linked to your account or other information that helps us identify the account.',
            'State whether you want to delete the account and all data, or only selected data.',
            'To protect account security, we may need to verify your identity before processing the request.'
          ]
        },
        {
          title: '4. Deletion scope',
          paragraphs: ['For account deletion, the following scope applies to final deletion or anonymization after the 7-day cooling-off period ends and you have not cancelled the request. This usually includes:'],
          bullets: [
            'Account information and login identifiers, such as account ID, linked email address, and login authorization records.',
            'Profile information and in-app settings, such as nickname, avatar, and preferences.',
            'Content you generated, submitted, or saved in the service, such as conversations, interaction records, feedback, or customer support communications.',
            'Device information, usage records, error logs, and security logs that can be associated with the account.'
          ]
        },
        {
          title: '5. Retention reasons',
          paragraphs: ['Some data may not be deleted immediately after the 7-day cooling-off period due to necessary reasons. Such data will only be retained to the extent necessary and will be deleted or anonymized when the retention reason no longer exists or the retention period ends:'],
          bullets: [
            'Records that must be retained for legal, compliance, tax, accounting, or audit requirements.',
            'Transaction, payment, refund, invoice, or benefit distribution records, where applicable.',
            'Security logs used for account security, anti-abuse, risk control, troubleshooting, and fraud prevention.',
            'Records necessary to handle disputes, complaints, customer support requests, or protect legal rights.',
            'Copies stored in backup systems.'
          ]
        },
        {
          title: '6. Retention period',
          paragraphs: ['After an account deletion request enters the 7-day cooling-off period, if you do not cancel the request during that period, we will delete or anonymize the relevant personal data after the cooling-off period ends. Unless a longer period is required by law, regulation, security needs, dispute handling, or compliance audit obligations, we will not continue retaining personal data of the deleted account. Data copies in backup systems will be cleared or isolated according to the backup rotation cycle and will not be used for routine business access. Data retained for legal or necessary purposes will only be kept until the relevant purpose is fulfilled or the legally required period expires.']
        }
      ],
      contactLabel: 'Contact email:',
      contactEmail: 'support@fuzozo.net'
    }
  },
  ja: {
    dataDeletion: {
      title: 'アカウントおよびデータ削除のご案内',
      intro: 'Fuzozoアカウントの削除、関連するすべてのデータの削除、または選択した個人データの削除をリクエストできます。アカウント削除には7日間のクーリングオフ期間があります。このページでは、リクエストの提出方法、削除対象範囲、保持理由、保持期間について説明します。',
      sections: [
        {
          title: 'アカウント削除と7日間のクーリングオフ期間',
          paragraphs: ['アカウントおよび関連するすべての個人データの削除を希望する場合は、Fuzozoアプリ内からアカウント削除を申請できます。申請後、アカウント削除は7日間のクーリングオフ期間に入ります。この期間中は、最終的な削除はすぐには完了しません。期間終了までに削除を取り消さなかった場合、当社は当該アカウントに関連する個人データを削除または匿名化します。完了後は、アカウントを復元することはできません。'],
          steps: [
            'Fuzozoアプリを開き、削除したいアカウントにサインインします。',
            '「設定」に移動します。',
            '画面を一番下までスクロールし、「アカウントを削除」を選択します。',
            '確認メッセージを読み、「アカウントを削除」をタップして申請を送信します。',
            '申請後、7日間のクーリングオフ期間が開始されます。この期間中に取り消しを行わない場合、アカウントおよび関連する個人データは最終削除または匿名化の処理に進みます。'
          ]
        },
        {
          title: '選択したデータの削除',
          paragraphs: ['アカウント全体を削除せずに、特定のデータのみ削除したい場合は、メールでリクエストを送信してください。削除を希望するデータの種類または期間を記載してください。たとえば、プロフィール情報、会話または利用記録、カスタマーサポート記録、その他お客様が提供したコンテンツなどです。']
        },
        {
          title: 'リクエストの提出方法',
          paragraphs: ['アプリ内のアカウント削除機能から、アカウント削除を申請できます。アカウントにアクセスできない場合、または選択したデータのみ削除したい場合は、メールでご連絡ください。'],
          bullets: [
            'アカウントに紐づくメールアドレス、またはアカウントを特定するために役立つその他の情報を記載してください。',
            'アカウントとすべてのデータの削除を希望するのか、選択したデータのみの削除を希望するのかを明記してください。',
            'アカウントの安全性を保護するため、リクエスト処理前に本人確認をお願いする場合があります。'
          ]
        },
        {
          title: '削除対象範囲',
          paragraphs: ['アカウント削除の場合、7日間のクーリングオフ期間終了後、かつその間にリクエストを取り消していない場合、以下の範囲が最終削除または匿名化の対象となります。通常、これには以下が含まれます。'],
          bullets: [
            'アカウント情報およびログイン識別子（アカウントID、連携済みメールアドレス、ログイン認証記録など）。',
            'プロフィール情報およびアプリ内設定（ニックネーム、アバター、各種設定など）。',
            'サービス内でお客様が生成、送信、または保存したコンテンツ（会話、利用記録、フィードバック、カスタマーサポートとのやり取りなど）。',
            'アカウントに関連付けられる端末情報、利用記録、エラーログ、セキュリティログ。'
          ]
        },
        {
          title: '保持理由',
          paragraphs: ['一部のデータは、必要な理由により、7日間のクーリングオフ期間終了後も直ちに削除されない場合があります。これらのデータは必要な範囲に限って保持され、保持理由がなくなった時点、または保持期間の終了時点で削除または匿名化されます。'],
          bullets: [
            '法令、コンプライアンス、税務、会計、または監査上の要件により保持が必要な記録。',
            '該当する場合の取引、支払い、返金、請求書、または特典配布に関する記録。',
            'アカウントの安全確保、不正利用防止、リスク管理、障害調査、不正防止のために使用されるセキュリティログ。',
            '紛争、苦情、カスタマーサポートへの問い合わせへの対応、または法的権利の保護に必要な記録。',
            'バックアップシステムに保存されたコピー。'
          ]
        },
        {
          title: '保持期間',
          paragraphs: ['アカウント削除リクエストが7日間のクーリングオフ期間に入った後、その期間中にリクエストを取り消さなかった場合、当社はクーリングオフ期間終了後に関連する個人データを削除または匿名化します。法令、規制、セキュリティ上の必要性、紛争対応、またはコンプライアンス監査義務により、より長い期間の保持が必要な場合を除き、削除済みアカウントの個人データを継続して保持することはありません。バックアップシステム内のデータコピーは、バックアップのローテーション周期に従って消去または隔離され、通常の業務アクセスには使用されません。法的または必要な目的で保持されるデータは、関連する目的が達成されるまで、または法令で定められた保持期間が満了するまでのみ保持されます。']
        }
      ],
      contactLabel: 'お問い合わせメールアドレス：',
      contactEmail: 'support@fuzozo.jp'
    }
  },
  'zh-TW': {
    dataDeletion: {
      title: '帳號與資料刪除說明',
      intro: '您可以要求刪除 Fuzozo 帳號、刪除全部相關資料，或僅刪除部分個人資料。帳號註銷流程設有 7 天冷靜期；本頁說明提交方式、刪除範圍、保留原因和保留期限。',
      sections: [
        {
          title: '1. 帳號註銷與 7 天冷靜期',
          paragraphs: ['若您希望刪除帳號及全部相關個人資料，可以在 Fuzozo 應用程式內提交帳號註銷申請。提交後，帳號註銷會進入 7 天冷靜期。冷靜期內，帳號不會立即完成最終刪除；冷靜期結束且您未取消註銷的，我們會刪除或匿名化與該帳號相關的個人資料，刪除完成後帳號無法復原。'],
          steps: [
            '打開 Fuzozo 應用程式，並登入您要刪除的帳號。',
            '進入「我的」頁面。',
            '滑動至頁面底部並選擇「刪除帳號」。',
            '閱讀確認提示後，點擊「刪除」或「註銷帳號」提交申請。',
            '提交後進入 7 天冷靜期；冷靜期結束且未取消註銷的，帳號及相關個人資料將進入最終刪除或匿名化處理。'
          ]
        },
        {
          title: '2. 刪除部分資料',
          paragraphs: ['若您只希望刪除部分資料，而非註銷整個帳號，可以透過電子郵件提交申請。請說明您希望刪除的資料類型或時間範圍，例如個人資料、對話/互動記錄、客服記錄或其他您提供的內容。']
        },
        {
          title: '3. 提交方式',
          paragraphs: ['您可以透過應用程式內的帳號刪除入口提交帳號註銷申請。若您無法登入帳號，或需要刪除部分資料，請寄送電子郵件給我們。'],
          bullets: [
            '請在郵件中提供與帳號綁定的電子郵件地址，或其他可用於定位帳號的資訊。',
            '請說明您要註銷帳號及刪除全部資料，還是僅刪除部分資料。',
            '為保護帳號安全，我們可能需要進行必要的身分驗證後再處理請求。'
          ]
        },
        {
          title: '4. 刪除範圍',
          paragraphs: ['帳號註銷場景下，刪除範圍適用於 7 天冷靜期結束且您未取消註銷後的最終刪除或匿名化處理。刪除範圍通常包括：'],
          bullets: [
            '帳號資料和登入識別資訊，例如帳號 ID、綁定電子郵件、登入授權記錄。',
            '個人資料和應用程式內設定，例如暱稱、頭像、偏好設定。',
            '您在服務中產生、提交或保存的內容，例如對話、互動記錄、意見回饋或客服溝通內容。',
            '可歸屬於該帳號的裝置資訊、使用記錄、錯誤日誌和安全日誌。'
          ]
        },
        {
          title: '5. 保留原因',
          paragraphs: ['以下資料可能因必要原因不會在 7 天冷靜期結束後立即刪除，但只會在必要範圍內保存，並會在保留原因消失或保留期限屆滿後刪除或匿名化：'],
          bullets: [
            '法律、合規、稅務、會計或稽核要求必須保存的記錄。',
            '交易、付款、退款、發票或權益發放記錄（如適用）。',
            '用於帳號安全、反濫用、風險控制、故障排查和防止詐欺的安全日誌。',
            '為處理爭議、投訴、客服請求或保護合法權益所必需的記錄。',
            '備份系統中的資料副本。'
          ]
        },
        {
          title: '6. 保留期限',
          paragraphs: ['帳號註銷進入 7 天冷靜期後，如您未在冷靜期內取消註銷，我們會在冷靜期結束後刪除或匿名化相關個人資料。除法律法規另有要求，或為安全、爭議處理、合規稽核等必要目的需要繼續保留外，我們不會繼續保留已註銷帳號的個人資料。備份系統中的資料會隨備份輪替週期清除或隔離，不再用於日常業務存取。依法或出於必要目的保留的資料，將僅保存至對應目的完成或適用法律要求的期限屆滿。']
        }
      ],
      contactLabel: '聯絡信箱：',
      contactEmail: 'support@fuzozo.net'
    }
  }
}
